import axios from 'axios';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { UserProfile } from '@/app/_lib/interfaces';

export const getUserProfileKey = (userId?: string) => {
  return `/api/user/profile-${userId}`;
};

export const useUserProfileFetcher = (userId: string, disabled: boolean) => {
  return useSWR(disabled ? null : getUserProfileKey(userId), () =>
    axios.get(`/api/user/profile`).then(({ data }) => data as UserProfile)
  );
};

export const useUpdateUserProfileMutation = (userId: string) => {
  return useSWRMutation(
    getUserProfileKey(userId),
    (_: string, { arg: userProfile }: { arg: Partial<UserProfile> }) =>
      axios.patch(`/api/user/profile`, userProfile)
  );
};
